import axios from 'axios'
import { toast } from 'react-toastify'
import { log_out } from './auth';

export default function api(nonApiRoute = false) {
    const api = axios.create({
        baseURL: `${nonApiRoute ? '/' : '/api'}`,
        withCredentials: true,
        // Don't send a statically-baked CSRF token: `window.secure_token` is
        // rendered once at page load and goes stale after Fortify regenerates
        // the session on login (the SPA never reloads), causing every
        // state-changing request to 419 -> logout. Instead rely on axios's
        // built-in XSRF handling, which reads the live `XSRF-TOKEN` cookie
        // (refreshed by Laravel on every response) and sends `X-XSRF-TOKEN`.
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })

    api.interceptors.response.use(response => response, error => {
        const status = error.response?.status;

        if (status === 401 || status === 419) {
            log_out();
            window.location.href = '/login';

            return Promise.reject({status, errors: ['Unauthorized']})
        }

        if (status === 422) {
            let errors = Object.values(error?.response?.data?.errors || {})

            return Promise.reject({status: 422, errorsRaw: errors, errors: errors.reduce(error => error)})
        }

        // Surface unexpected failures (500s, network errors) for state-changing
        // requests so they don't fail silently. Reads (GET) stay quiet to avoid
        // noise from background polling.
        const method = (error.config?.method || '').toLowerCase();
        if (['post', 'put', 'patch', 'delete'].includes(method)) {
            toast.error('Something went wrong. Please try again.');
        }

        console.error(error);

        return Promise.reject({status, errors: ['Oops!']})
    });

    return api
}
